export const invoiceListDemoData = [
    {
        id: 18,
        customInvoiceNo: 'INV202510018',
        quotationNo: 'QUO202510018',
        isQuotation: false,
        firstName: 'Bipon',
        lastName: 'Biswas',
        organization: 'CityMedical',
        userId: 72,
        agencyId: 70,
        fullName: 'Bipon Biswas',
        email: 'hello@bikiran.com',
        invoiceTitle: 'EnvisionNEXT - CityMedical',
        timeDue: 1763149709,
        timeIssue: 1760536109,
        timeCanceled: 0,
        timeCreated: 1760536109,
        timeUpdated: 1760614566,
        authorizedBy: 0,
        amountBill: 1750,
        amountPaid: 0,
        currency: 'USD',
        status: 'due',
        agency: {
            id: 70,
            fullName: 'Bikiran Org',
            organization: 'Bikiran2',
            email: 'info@noman.me'
        },
        demo: true
    },
    {
        id: 16,
        customInvoiceNo: 'INV-202510016',
        quotationNo: 'QUO202510016',
        isQuotation: false,
        firstName: '',
        lastName: '',
        organization: 'Bikiran',
        userId: 79,
        agencyId: 66,
        fullName: '',
        email: '',
        invoiceTitle: 'Service Purchase ',
        timeDue: 1763049507,
        timeIssue: 1760435907,
        timeCanceled: 0,
        timeCreated: 1760435907,
        timeUpdated: 1760435907,
        authorizedBy: 0,
        amountBill: 1000,
        amountPaid: 0,
        currency: 'THB',
        status: 'due',
        agency: {
            id: 66,
            fullName: 'Wang Hoa',
            organization: 'Fujifilm Vietnam'
        },
        demo: true
    }
];

export default null;
